import React from "react";
import { ShieldCheck, BookOpen, Scale } from "lucide-react";

/**
 * Compact badge that signals miapoyo's legal-aid alignment.
 * Cita los frameworks oficiales y las organizaciones cuyas
 * metodologías inspiran el contenido.
 */
export default function LegalValidationBadge({ variant = "full" }) {
  if (variant === "compact") {
    return (
      <div
        data-testid="legal-validation-badge-compact"
        className="inline-flex items-center gap-2 bg-emerald-50 border border-emerald-300 rounded-full px-3 py-1.5 text-[11px] font-bold text-emerald-900"
      >
        <ShieldCheck className="w-3.5 h-3.5 text-emerald-700" />
        Alineado con PBNDS 2011 §&nbsp;6.3 · Florence · NIJC
      </div>
    );
  }

  return (
    <div
      data-testid="legal-validation-badge"
      className="bg-white border-2 border-emerald-300 rounded-2xl p-5 shadow-sm"
    >
      <div className="flex items-start gap-3 mb-3">
        <div className="flex-shrink-0 w-11 h-11 rounded-xl bg-emerald-600 text-white flex items-center justify-center">
          <ShieldCheck className="w-6 h-6" strokeWidth={2.5} />
        </div>
        <div>
          <p className="text-[10px] font-black uppercase tracking-widest text-emerald-700 mb-1">
            Marco legal de respaldo
          </p>
          <h3 className="text-base font-black text-zinc-900 leading-tight">
            Validado contra los estándares oficiales
          </h3>
        </div>
      </div>

      <p className="text-xs text-zinc-700 leading-snug mb-3">
        miapoyo NO es un despacho de abogados. Somos información educativa de auto-ayuda construida
        sobre los mismos marcos legales que usan las organizaciones pro-bono más reconocidas del
        país:
      </p>

      <ul className="space-y-2 text-xs">
        <li className="flex items-start gap-2">
          <Scale className="w-3.5 h-3.5 text-emerald-700 flex-shrink-0 mt-0.5" />
          <span className="text-zinc-800">
            <span className="font-black">PBNDS 2011 §&nbsp;6.3</span> — &laquo;Law Libraries and Legal
            Material&raquo; del ICE, que autoriza materiales de auto-ayuda en centros de detención.
          </span>
        </li>
        <li className="flex items-start gap-2">
          <BookOpen className="w-3.5 h-3.5 text-emerald-700 flex-shrink-0 mt-0.5" />
          <span className="text-zinc-800">
            <span className="font-black">Florence Project</span> y{" "}
            <span className="font-black">NIJC</span> — metodología de los pro-se asylum packets
            usados por las dos redes pro-bono más reconocidas del país.
          </span>
        </li>
        <li className="flex items-start gap-2">
          <ShieldCheck className="w-3.5 h-3.5 text-emerald-700 flex-shrink-0 mt-0.5" />
          <span className="text-zinc-800">
            <span className="font-black">USCIS I-589 (rev. 2024)</span> y manuales de la corte EOIR
            — instrucciones oficiales del Departamento de Justicia.
          </span>
        </li>
        <li className="flex items-start gap-2">
          <Scale className="w-3.5 h-3.5 text-emerald-700 flex-shrink-0 mt-0.5" />
          <span className="text-zinc-800">
            <span className="font-black">Doctrina constitucional Pro Se</span> — derecho federal a la
            auto-representación civil reconocido desde <em>Faretta v. California</em> (1975).
          </span>
        </li>
      </ul>

      <div className="mt-3 pt-3 border-t border-zinc-200">
        <p className="text-[11px] text-zinc-600 leading-snug">
          <span className="font-bold">Aviso:</span> El uso de estos marcos NO implica endoso,
          afiliación o sociedad con las organizaciones citadas. miapoyo es responsable únicamente
          de su propio contenido educativo.
        </p>
      </div>
    </div>
  );
}
